export default {
  fillRequiredFields: "Voer alle verplichte velden in."
}
